import { useMemo, useId } from 'react';
import { useDispatch } from 'react-redux';
import { Text, Button, OverlayTrigger, Glyphicon, Popover } from 'reaxl';
import { sendClick } from 'reaxl-analytics';
import { walletImportSettingsClick } from 'reaxl-analytics-handlers';
import { BrowserStorage } from '@atc/browser-storage';
import { jsxs, jsx } from 'react/jsx-runtime';
const lastSyncCache = /* #__PURE__*/new BrowserStorage('LAST_WALLET_SYNC', {
  persist: true
});
const formatDateToMMDD = function () {
  let date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  const month = date.toLocaleDateString('en-US', {
    month: '2-digit'
  });
  const day = date.toLocaleDateString('en-US', {
    day: '2-digit'
  });
  return `${month}/${day}`;
};
function SyncBannerInfoIcon(_ref) {
  let {
    onMyWalletClick: handleMyWalletClick
  } = _ref;
  const popoverId = useId();
  const popoverContent = /*#__PURE__*/jsx(Popover, {
    id: popoverId,
    width: "narrow",
    children: /*#__PURE__*/jsxs(Text, {
      children: [/*#__PURE__*/jsx(Text, {
        weight: "bold",
        children: "Save time car shopping!"
      }), " Your shopping preferences (ie: down payment, trade-in, etc.) will travel with you across devices and hundreds of dealer websites whenever you see", /*#__PURE__*/jsxs(Button, {
        bsStyle: "text-decorated",
        className: "display-inline-block margin-left-1",
        onClick: handleMyWalletClick,
        children: [/*#__PURE__*/jsx(Glyphicon, {
          className: "padding-right-1",
          glyph: "wallet"
        }), "My Wallet"]
      })]
    })
  });
  return /*#__PURE__*/jsx(OverlayTrigger, {
    className: "cursor-pointer",
    placement: "top",
    rootClose: true,
    trigger: "click",
    overlay: popoverContent,
    children: /*#__PURE__*/jsx(Glyphicon, {
      "aria-label": "more info",
      glyph: "info",
      className: "margin-left-1 margin-right-2"
    })
  });
}
function WalletSyncBanner(_ref2) {
  let {
    paymentsDuck,
    updateMyWallet = () => {}
  } = _ref2;
  const dispatch = useDispatch();
  const lastDateSync = lastSyncCache.getItem();

  // syncCTA variable that updates whenever lastDateSync changes
  const syncCTAText = useMemo(() => lastDateSync ? `Last Sync: ${formatDateToMMDD(new Date(lastDateSync))}` : 'Sync My Wallet', [lastDateSync]);
  const handleMyWalletDashboardClick = event => {
    sendClick(walletImportSettingsClick, event, {
      isLastSync: !!lastDateSync
    });
    const walletSyncInfo = {
      selectedPanelName: 'walletCentral',
      hideBackButton: false
    };
    updateMyWallet({
      displayModal: true,
      ...walletSyncInfo
    });
    if (paymentsDuck?.creators?.updateMyWalletInteractions) {
      dispatch(paymentsDuck.creators.updateMyWalletInteractions({
        hasOpenedWalletCentral: true
      }));
    }
  };
  return /*#__PURE__*/jsxs(Text, {
    "data-cmp": "udsWalletSyncBanner",
    size: 200,
    className: "padding-top-1",
    children: ["Shopping across sites or devices?", /*#__PURE__*/jsx(SyncBannerInfoIcon, {
      onMyWalletClick: () => updateMyWallet({
        displayModal: true
      })
    }), /*#__PURE__*/jsx(Button, {
      bsStyle: "text-decorated",
      onClick: handleMyWalletDashboardClick,
      "data-cmp": "udsWalletSyncCTA",
      "aria-label": `Wallet sync: ${syncCTAText}`,
      children: syncCTAText
    })]
  });
}
export { WalletSyncBanner as default };
